var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "facePanelCover",
    on: {
      "click": _vm.closeClick
    }
  }, [_c('div', {
    staticClass: "facePanel",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": "https://imagessl.lingtuo.cn/A-1ed71af7_20241025101113.png"
    },
    on: {
      "click": _vm.closeClick
    }
  }), _c('div', {
    staticClass: "emojiIconList"
  }, _vm._l(_vm.emojiList, function (emoji) {
    return _c('div', {
      key: emoji.emoji,
      staticClass: "emojiIconListItem",
      on: {
        "click": function ($event) {
          return _vm.emojiClick(emoji);
        }
      }
    }, [_c('div', [_vm._v(_vm._s(emoji.emoji))])]);
  }), 0), _c('div', {
    staticClass: "typeBar"
  }, [_c('img', {
    staticClass: "typeBarBtn",
    attrs: {
      "src": "https://imagessl.lingtuo.cn/A-1ed71af7_20241025102335.png"
    },
    on: {
      "click": function ($event) {
        return _vm.scrollBtnClick('left');
      }
    }
  }), _c('img', {
    staticClass: "typeBarBtn",
    style: {
      'left': 'unset',
      'right': '8px'
    },
    attrs: {
      "src": "https://imagessl.lingtuo.cn/A-1ed71af7_20241025102402.png"
    },
    on: {
      "click": function ($event) {
        return _vm.scrollBtnClick('right');
      }
    }
  }), _c('div', {
    ref: "typeBarList",
    staticClass: "typeBarList"
  }, _vm._l(_vm.emojiTypeList, function (emojiType) {
    return _c('div', {
      key: emojiType.categoryName,
      staticClass: "typeBarListItem",
      on: {
        "click": function ($event) {
          return _vm.emojiTypeClick(emojiType);
        }
      }
    }, [_vm._v(_vm._s(emojiType.categoryName))]);
  }), 0)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };